import { add as snackbarAdd } from "actions/snackbars";
import { requestAsync } from "lib/api";
import { getQuery } from "queries/view-defs";
import Globalize from "globalize";

import { VIEW_FAILURE, VIEW_REQUEST, VIEW_RESET, VIEW_SUCCESS } from "constants/action-types";

export const clearViews = () => {
    return {
        type: VIEW_RESET,
    };
};

export const fetchViewForSchema = (key: string, schemaId: string | undefined, viewAsGuestBuyer: boolean) => {
    return (dispatch, getState) => {
        dispatch({
            type: VIEW_REQUEST,
        });
        dispatch(requestAsync(getQuery(key, schemaId, viewAsGuestBuyer))).then(({ status, translated, body }) => {
            if (status >= 200 && status < 300) {
                dispatch({
                    meta: {
                        replace: true,
                    },
                    payload: [body._id],
                    type: VIEW_SUCCESS,
                });
            } else {
                dispatch({
                    error: true,
                    payload: body && new Error(body.message),
                    type: VIEW_FAILURE,
                });
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("Oops! Something went wrong. Please refresh and try again."),
                    })
                );
            }
        });
    };
};

export const fetchViewsComplete = (data) => {
    const { status, transformed, body } = data;
    return (dispatch, getState) => {
        if (status >= 200 && status < 300) {
            dispatch({
                meta: {
                    replace: true,
                },
                payload: transformed._result,
                type: VIEW_SUCCESS,
            });
        } else {
            dispatch({
                error: true,
                payload: body && new Error(body.message),
                type: VIEW_FAILURE,
            });
            dispatch(
                snackbarAdd({
                    message: Globalize.formatMessage("Oops! Something went wrong. Please refresh and try again."),
                })
            );
        }
    };
};
